import React, { createContext, useContext } from 'react';
import type { EventLogger } from './eventLogger.client';

const defaultEventLogger: EventLogger = { getPathname: () => '' };

const EventLoggerContext = createContext<EventLogger | undefined>(undefined);

interface EventLoggerProviderProps {
    eventLogger?: EventLogger;
    children: React.ReactNode;
}

export const EventLoggerProvider: React.FC<EventLoggerProviderProps> = ({
    eventLogger = defaultEventLogger,
    children,
}) => {
    return (
        <EventLoggerContext.Provider value={eventLogger}>{children}</EventLoggerContext.Provider>
    );
};

export const useEventLogger = (): EventLogger => {
    return useContext(EventLoggerContext) ?? defaultEventLogger;
};
